import { render, staticRenderFns } from "./UploadResult.vue?vue&type=template&id=89d21ea0&"
import script from "./UploadResult.vue?vue&type=script&lang=ts&"
export * from "./UploadResult.vue?vue&type=script&lang=ts&"
import style0 from "./UploadResult.vue?vue&type=style&index=0&id=89d21ea0&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QCardSection,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QBtn})
